import { AuthGuard } from "../../auth/helpers";
import { AssetsListComponent } from "./pages/list/assets-list.component";
import { AssetsFormComponent } from "./pages/form/assets-form.component";
import { AssetsDetailComponent } from "./pages/detail/assets-detail.component";
import { AssetImportComponent } from "./pages/import/asset-import.component";
import { AssetCategoriesComponent } from "./pages/categories/asset-categories.component";
import { StaffAssetsDocumentListComponent } from "./pages/staff-assets-document-list/staff-assets-document-list.component";

import { IRoute } from "app/auth/models/utils-interfaces";

const assetsRoutes: IRoute[] = [
  //assets
  {
    path: "dashboard/assets/list",
    component: AssetsListComponent,
    canActivate: [AuthGuard],
    capability: "view_assets_list",
    data: { animation: "flatpickr" },
  },
  //assets add
  {
    path: "dashboard/assets/add",
    component: AssetsFormComponent,
    canActivate: [AuthGuard],
    capability: "view_assets_list",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/documents/assets-list",
    component: StaffAssetsDocumentListComponent,
    canActivate: [AuthGuard],
    capability: "show_assets_documents",
    data: { animation: "flatpickr" },
  },
  //assets edit
  {
    path: "dashboard/assets/edit/:id",
    component: AssetsFormComponent,
    canActivate: [AuthGuard],
    capability: "view_assets_list",
    data: { animation: "flatpickr" },
  },
  //assets detail
  {
    path: "dashboard/assets/detail/:id",
    component: AssetsDetailComponent,
    canActivate: [AuthGuard],
    capability: "", //implementare capability
    data: { animation: "flatpickr" },
  },
  //Lista utenti(per ogni utente si visualizza un template)
  {
    path: "dashboard/assets/import",
    component: AssetImportComponent,
    canActivate: [AuthGuard],
  },
  // Lista categorie asset
  {
    path: "dashboard/asset/categories_list",
    component: AssetCategoriesComponent,
    canActivate: [AuthGuard],
    capability: "show_categories_asset",
    data: { animation: "flatpickr" },
  },
];
export default assetsRoutes;
